import { IAuditAdapter } from './IAuditAdapter';
import { ApiResponse } from '../../types/api';
import {
  AuditLog,
  AuditLogFilter,
  PaginatedAuditLogs,
  SecuritySettings,
  UpdateSecuritySettingsDto,
  ActiveSession,
  LoginHistoryEntry,
} from '../../types/audit';
import { ApiClient } from '../apiClient';

export class LaravelAuditAdapter implements IAuditAdapter {
  async getAuditLogs(filter?: AuditLogFilter): Promise<ApiResponse<PaginatedAuditLogs>> {
    const query = filter ? `?${new URLSearchParams(filter as any).toString()}` : '';
    return ApiClient.get<PaginatedAuditLogs>(`/api/v1/audit-logs${query}`);
  }

  async getAuditLogById(id: string): Promise<ApiResponse<AuditLog>> {
    return ApiClient.get<AuditLog>(`/api/v1/audit-logs/${id}`);
  }

  async getEntityHistory(entityType: string, entityId: string): Promise<ApiResponse<AuditLog[]>> {
    return ApiClient.get<AuditLog[]>(`/api/v1/audit-logs/entity/${entityType}/${entityId}`);
  }

  async exportAuditLogs(filter?: AuditLogFilter): Promise<ApiResponse<AuditLog[]>> {
    return ApiClient.post<AuditLog[]>('/api/v1/audit-logs/export', filter || {});
  }

  async createAuditLog(log: Partial<AuditLog>): Promise<ApiResponse<AuditLog>> {
    return ApiClient.post<AuditLog>('/api/v1/audit-logs', log);
  }

  async getSecuritySettings(): Promise<ApiResponse<SecuritySettings>> {
    return ApiClient.get<SecuritySettings>('/api/v1/security/settings');
  }

  async updateSecuritySettings(dto: UpdateSecuritySettingsDto): Promise<ApiResponse<SecuritySettings>> {
    return ApiClient.put<SecuritySettings>('/api/v1/security/settings', dto);
  }

  async getActiveSessions(): Promise<ApiResponse<ActiveSession[]>> {
    return ApiClient.get<ActiveSession[]>('/api/v1/security/sessions');
  }

  async revokeSession(id: string): Promise<ApiResponse<void>> {
    return ApiClient.delete<void>(`/api/v1/security/sessions/${id}`);
  }

  async getLoginHistory(userId?: string): Promise<ApiResponse<LoginHistoryEntry[]>> {
    return ApiClient.get<LoginHistoryEntry[]>(`/api/v1/security/login-history${userId ? `?user_id=${userId}` : ''}`);
  }
}
